import { FaRobot, FaCheckDouble, FaSlidersH } from "react-icons/fa";
import { ENUM_ROLES }  from "../../../interaces/enums/enums.interface";
export const TABS_AI_ASSISTANT = [
  { id: 'CHAT', icon: <FaRobot />,roles: [ENUM_ROLES.GOVERNMENT_OFFICIAL,ENUM_ROLES.SUPERADMIN] },
  { id: 'PANEL DE CONTROL', icon: <FaSlidersH  />,roles: [ENUM_ROLES.SUPERADMIN] },
];
export const ENUM_TABS_AI_ASSISTANT = {
  CHAT: 'CHAT',
  PANEL_DE_CONTROL: 'PANEL DE CONTROL',
};

export const SUGGESTIONS = [
  '¿Cuántos certificados ciudadanos hay emitidos?',
  '¿Cuántas empresas están registradas en el sistema?',
  '¿Qué dependencias existen en el catálogo?',
  '¿Cuáles certificados están vigentes?',
];

export const ENUM_MESSAGES_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant',
};